import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AccessType } from '@classes/access-type';
import { AccessTypeService } from 'app/core/services/access-type.service';
import { UiService } from 'app/core/services/ui.service';
import { AccessTypeDetailComponent } from '../access-type-detail/access-type-detail.component';

@Component({
  selector: 'app-access-type-grid',
  templateUrl: './access-type-grid.component.html',
  styleUrls: ['./access-type-grid.component.scss']
})
export class AccessTypeGridComponent implements OnInit {

  dataSource = new MatTableDataSource<AccessType>();
  pageSizeOptions = [25, 50, 100];
  selectedRowID: string;
  displayedColumns: string[] = [
    'name',
    // 'modifiedDate',
    // 'userName',
    'action'
  ];

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) MatPaginatorAccessType: MatPaginator;

  constructor(
    public accessTypeService: AccessTypeService,
    public uiService: UiService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.getAccessTypes();
  }
  getAccessTypes() {
    this.uiService.addRouteLoading();
    this.accessTypeService.getAccessTypes().subscribe(accessTypes => {
      this.dataSource.data = accessTypes;
      this.uiService.removeRouteLoading();
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    });
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.MatPaginatorAccessType;
    this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
      if (typeof data[sortHeaderId] === 'string') {
        return data[sortHeaderId].toLocaleLowerCase();
      }
    
      return data[sortHeaderId];
    };
  }

  selectItemClick(item: AccessType) {
    this.selectedRowID = item.id || '';
  }
  editElement(item: AccessType) {
    const data = new AccessType({
      id: item.id || "",
      name: item.name || ""
    });
    const dialogRef = this.dialog.open(AccessTypeDetailComponent, {
      data,
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(success => {
      if (success) {
        this.getAccessTypes();
      }
    });
  }

}
